import { render, staticRenderFns } from "./NotificationPostReview.vue?vue&type=template&id=48bbbbec&scoped=true&"
import script from "./NotificationPostReview.vue?vue&type=script&lang=ts&"
export * from "./NotificationPostReview.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationPostReview.vue?vue&type=style&index=0&id=48bbbbec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bbbbec",
  null
  
)

export default component.exports